export default "__VITE_ASSET__DYtexq8g__"